import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Menu from "../../components/Menu";
import contratoIcon from "../../image/contratoIcon.png";
import faturaIcon from "../../image/faturaIcon.png";
import coletaIcon from "../../image/coletaIcon.png";
import coletaExtraIcon from "../../image/coletaExtraIcon.png";
import atendimentoIcon from "../../image/atendimentoIcon.png";
import contratoIcon2 from "../../image/contratoIcon2.png";
import Slide from "@mui/material/Slide";
import { animateScroll as scroll } from "react-scroll";
import GroupAdd from '@mui/icons-material/GroupAdd';

import Contrato from "../Contrato";
import Faturas from "../Faturas";
import Coletas from "../Coletas";

import "./style.css";
import api from "../../services/api";
import Loading from "../../components/Loading";
import Atendimentos from "../Atendimentos";
import ColetaExtra from "../ColetaExtra";
import {
  getContrato,
  getContratos,
  getFirstLogin,
  getUsername,
  getUsuarioCargoId,
  getUsuarioSetorId,
  logout,
  setContrato,
  setContratos,
  setFirstLogin,
} from "../../services/auth";
import { AlertTitle, Badge, Drawer, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { token } from "../../services/firebase";
import { onMessage } from "firebase/messaging";
import Notificacoes from "../Notificacoes";
import ModalAviso from "./components/ModalAviso";
import { logNavegacao } from "../../function";
import AnimatedComponent from "./components/AnimatedComponent";
import EventNoteIcon from "@mui/icons-material/EventNote";
import Usuarios from "../Usuarios";
import nest from "../../services/nest";

function Home({ history }) {
  let initialized2 = false;
  const setorId = getUsuarioSetorId() ? getUsuarioSetorId() / 1 : 0;
  const cargoId = getUsuarioCargoId() ? getUsuarioCargoId() / 1 : 0;
  const firebase = async () => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        let messaging = token();
        onMessage(messaging, (payload) => {
          let { data } = payload;
          setTransition(() => TransitionLeft);
          setAlerta({
            type: "info",
            msg: data.Body,
            title: data.Title,
            show: true,
          });
          setNotificacao((data) => data + 1);
        });
      }
      initialized2 = false;
    });
  };
  const scrollToTop = () => {
    scroll.scrollToTop();
  };
  let verificar;
  useEffect(() => {
    scrollToTop();
    if (!initialized2) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      initialized2 = true;
      firebase();
      getNotification();
    }
    const firstLogin = getFirstLogin();
    if(firstLogin !== '2'){
      setFirstLogin('2')
      logout()
      window.location.reload()
    }
  }, []);
  const [alerta, setAlerta] = useState({
    type: "error",
    msg: "",
    show: false,
    title: "",
  });
  const [showContrato, setShowContrato] = useState(false);
  const [showFaturas, setShowFaturas] = useState(false);
  const [showColetas, setShowColetas] = useState(false);
  const [showAtendimentos, setShowAtendimentos] = useState(false);
  const [showColetaExtra, setShowColetaExtra] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    name: "",
    nameContrato: "",
    total: "",
    status: "",
    statusContrato: "",
    residuo: "",
    endereco: "",
    cnpj: "",
    consultor: "",
    vencimento: "",
    quantidade: 0,
    contratoColeta: "",
    quantidadeEmAberto: 0,
    tipo: "",
  });
  let contratosTemp = getContratos();
  const [idContrato, setIdContrato] = useState(null);
  useEffect(() => {
    let contratoTemp = getContrato();
    if (contratoTemp !== null) {
      setIdContrato(contratoTemp / 1);
    } else {
      try {
        setIdContrato(contratosTemp[0].id);
      } catch (e) {
        getContratosUsuario();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getContratosUsuario = () => {
    nest
    .get(`/clientes/PorUsuario`)
      .then(function (response) {
      setLoading(false)
      let dataTemp = response.data
      if (dataTemp != null) {
        if (!dataTemp.status) {
          setContratos(dataTemp)
          if (dataTemp.length === 1) {
            let id = dataTemp[0].id
            setContrato(id.toString())
          }
          window.location.reload()
        } else {
          if (dataTemp.status === 401) {
            //gerar novo token
          }
        }
      }
    })
    .catch(function (error) {
      logout()
      window.location.reload()
      console.log(error)
    })
  }
  let initialized = false;
  useEffect(() => {
    if (idContrato !== null) {
      const getUser = async () => {
        setLoading(true);
        const userName = getUsername();
        api
          .get(`/clients/contracts/` + idContrato + "/edit")
          .then(function (response) {
            setLoading(false);
            let { status, data } = response.data;
            if (status === true) {
              let total = null;
              let status = null;
              let vencimento = null;
              let quantidade = 0;
              if (data.receber != null) {
                total = data.receber.valor;
                status = data.receber.status;
                vencimento = data.receber.vencimento;
                quantidade = data.receber.quantidadeExtra;
              }
              let endereco = "";
              let residuo = "";
              let nameContrato = "";
              if (data.cliente != null) {
                endereco =
                  data.cliente.endereco +
                  " " +
                  data.cliente.numero +
                  " - " +
                  data.cliente.bairro;
                nameContrato = data.cliente.nome;
              }
              let tipo = "";
              let cnpj = null;
              if (data.cnpj != "") {
                cnpj = data.cnpj;
                tipo = "CNPJ";
              } else {
                cnpj = data.cpf;
                tipo = "CPF";
              }
              let contratoColeta = "";
              if (data.contratoColeta != "" && data.contratoColeta != null) {
                if (
                  data.contratoColeta.contrato_tipo_coleta != "" &&
                  data.contratoColeta.contrato_tipo_coleta != null
                ) {
                  contratoColeta =
                    data.contratoColeta.contrato_tipo_coleta.nome;
                }
              }
              setUser({
                name: userName !== "null" ? userName : data.cliente.contato,
                total,
                status,
                nameContrato,
                endereco,
                residuo,
                statusContrato: data.status,
                cnpj,
                consultor: data.consultor,
                vencimento,
                quantidade,
                contratoColeta,
                quantidadeEmAberto: data.quantidadeEmAberto,
                tipo,
              });
              if (data.status === "Contrato Suspenso") {
                handleShow();
              }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initialized = false;
          })
          .catch(function (error) {
            console.log(error);
            initialized = false;
          });
      };
      if (!initialized) {
        initialized = true;
        getUser();
        getHome(idContrato);
        if (verificar) clearInterval(verificar);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        verificar = setInterval(function () {
          getNotification();
          getHome(idContrato);
        }, 20000);
        return () => {
          clearInterval(verificar);
        };
      }
    }
  }, [idContrato]);
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleCloseAlerta = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlerta({
      type: "error",
      msg: "",
      show: false,
      title: "",
    });
  };
  let [visible, setVisible] = useState({
    cont: 0,
    ordem: false,
  });
  const getHome = (idContrato) => {
    api
      .get(`/clients/coleta/extra`, {
        headers: {
          idcontrato: idContrato,
        },
      })
      .then(function (response) {
        let { status, data, ordem } = response.data;
        if (status === true) {
          setVisible({ cont: data, ordem });
        } else {
          setVisible({ cont: 0, ordem });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handerColetaExtra = (value) => {
    setShowColetaExtra(value);
    api
      .get(`/clients/coleta/extra`, {
        headers: {
          idcontrato: idContrato,
        },
      })
      .then(function (response) {
        let { status, data } = response.data;
        if (status === true) {
          setVisible(data);
        } else {
          setVisible(0);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const [notificacao, setNotificacao] = useState(0);
  function getNotification() {
    api
      .get(`/clients/notifications/0`)
      .then(function (response) {
        let { status, data } = response.data;
        if (status === true) {
          setNotificacao(data);
        } else {
          setNotificacao(0);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const [transition, setTransition] = React.useState(undefined);
  function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
  }
  const [notify, showNotify] = useState(false);
  const [showUsuarios, setShowUsuarios] = useState(false);
  const [state, setState] = useState(false);
  const [mostrar, setmotrar] = useState(false);
  const handleClose = () => setmotrar(false);
  const handleShow = () => setmotrar(true);
  const openCronograma = () => {
    window.open(
      "https://greenium.com.br/admin/painel2.php?execute=suporte/relatorio/cronograma-pdf&contratoId=" +
        idContrato,
      "_blank",
      "noreferrer"
    );
  };
  return (
    <>
      <Loading open={loading} />
      <Header
        history={history}
        user={user}
        showNotify={showNotify}
        setNotificacao={setNotificacao}
        notificacao={notificacao}
        idContrato={idContrato}
        setShowUsuarios={setShowUsuarios}
      />
      <div
        className="home row"
        id="home"
        style={{ marginRight: 0, marginLeft: 0, height: window.innerHeight }}
      >
        <div
          className="col-12 col-sm-12 col-xs-12 col-md-3 col-lg-3 col-xl-3"
          id="menuShow"
        >
          <Drawer anchor={"left"} open={state} onClose={() => setState(false)}>
            <Menu
              contratos={contratosTemp}
              idContrato={idContrato}
              setIdContrato={setIdContrato}
              setState={setState}
            />
          </Drawer>
        </div>
        <div
          className="col-12 col-sm-12 col-xs-12 col-md-3 col-lg-3 col-xl-3"
          style={{ padding: 0 }}
          id="menuHide"
        >
          <div style={{ marginTop: 84 }}></div>
          <Menu
            contratos={contratosTemp}
            idContrato={idContrato}
            setIdContrato={setIdContrato}
            setState={setState}
          />
        </div>
        <div
          className="col-12 col-sm-12 col-xs-12 col-md-12 col-lg-9 col-xl-9"
          style={{
            padding: 0,
            overflowY: "auto",
            height: "calc(100% - 55px)",
            backgroundColor: "var(--main-fundo)",
          }}
        >
          <div id="cardBody"></div>
          {notify ? (
            <Notificacoes showNotify={showNotify} />
          ) : showUsuarios ? (
            <Usuarios
              setShowFaturas={setShowUsuarios}
              user={{
                idContrato,
                name: user.nameContrato,
                status: user.statusContrato,
                residuo: user.contratoColeta,
                cnpj: user.cnpj,
                endereco: user.endereco,
                consultor: user.consultor,
              }}
            />
          ) : showContrato ? (
            <Contrato
              setShowContrato={setShowContrato}
              data={{
                idContrato,
                name: user.nameContrato,
                status: user.statusContrato,
                residuo: user.contratoColeta,
                cnpj: user.cnpj,
                endereco: user.endereco,
                consultor: user.consultor,
                tipo: user.tipo,
              }}
            />
          ) : showFaturas ? (
            <Faturas
              setShowFaturas={setShowFaturas}
              user={{
                idContrato,
                name: user.nameContrato,
                status: user.statusContrato,
                residuo: user.contratoColeta,
                cnpj: user.cnpj,
                endereco: user.endereco,
                consultor: user.consultor,
              }}
            />
          ) : showColetas ? (
            <Coletas
              setShowColetas={setShowColetas}
              user={{
                idContrato,
                name: user.nameContrato,
                status: user.statusContrato,
                residuo: user.contratoColeta,
                cnpj: user.cnpj,
                endereco: user.endereco,
                consultor: user.consultor,
              }}
            />
          ) : showAtendimentos ? (
            <Atendimentos
              setShowAtendimentos={setShowAtendimentos}
              user={{
                idContrato,
                name: user.nameContrato,
                status: user.statusContrato,
                residuo: user.contratoColeta,
                cnpj: user.cnpj,
                endereco: user.endereco,
                consultor: user.consultor,
              }}
            />
          ) : showColetaExtra ? (
            <ColetaExtra
              setShowColetaExtra={handerColetaExtra}
              user={{
                idContrato,
                name: user.nameContrato,
                status: user.statusContrato,
                residuo: user.contratoColeta,
                cnpj: user.cnpj,
                endereco: user.endereco,
                consultor: user.consultor,
              }}
            />
          ) : (
            <div className="body">
              <ModalAviso mostrar={mostrar} handleClose={handleClose} />
              <div style={{ marginTop: 90 }}></div>
              <AnimatedComponent
                visible={visible}
                setShowColetas={setShowColetas}
              />
              <div
                style={{
                  fontSize: 30,
                  fontWeight: 700,
                  color: "var(--main-font)",
                }}
              >
                Fatura Atual
              </div>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 300,
                  color: "var(--main-secondy)",
                }}
              >
                Vencimento: {user.vencimento}
              </div>
              <div
                style={{
                  fontSize: 25,
                  fontWeight: 700,
                  color: "var(--main-font)",
                }}
              >
                {user.total}
              </div>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 300,
                  color: "var(--main-secondy)",
                }}
              >
                {user.status}
              </div>
              <div className="icones">
                {(setorId === 1 || setorId === 3) && (
                  <div
                    className="icone"
                    onClick={() => {
                      setShowFaturas(true);
                      logNavegacao("Navegacao", "Fatura");
                    }}
                  >
                    <Badge
                      badgeContent={user.quantidadeEmAberto}
                      overlap="circular"
                      color="error"
                      max={9}
                    >
                      <img
                        src={faturaIcon}
                        height="80"
                        width="80"
                        alt="Fatura"
                        style={{ height: 80, width: 80, minWidth: 80 }}
                      />
                    </Badge>
                    <div className="iconText">Fatura</div>
                  </div>
                )}
                {(setorId === 1 || setorId === 2) && (
                  <div
                    className="icone"
                    onClick={() => {
                      setShowColetas(true);
                      logNavegacao("Navegacao", "Coleta");
                    }}
                  >
                    <img
                      src={coletaIcon}
                      height="80"
                      width="80"
                      alt="Coleta"
                      style={{ height: 80, width: 80, minWidth: 80 }}
                    />
                    <div className="iconText">Coleta</div>
                  </div>
                )}
                {(setorId === 1 || setorId === 2) && (
                  <div
                    className="icone"
                    onClick={() => {
                      setShowColetaExtra(true);
                      logNavegacao("Navegacao", "Coleta Extra");
                    }}
                  >
                    <Badge
                      badgeContent={visible.cont}
                      overlap="circular"
                      color="error"
                      max={9}
                    >
                      <img
                        src={coletaExtraIcon}
                        height="80"
                        width="80"
                        alt="Coleta Extra"
                        style={{ height: 80, width: 80, minWidth: 80 }}
                      />
                    </Badge>
                    <div className="iconText">Coletas Extras</div>
                  </div>
                )}
                {cargoId === 1 && (
                  <div
                    className="icone"
                    onClick={() => {
                      setShowContrato(true);
                      logNavegacao("Navegacao", "Contrato");
                    }}
                  >
                    <img
                      src={contratoIcon}
                      height="80"
                      width="80"
                      alt="Contrato"
                      style={{ height: 80, width: 80, minWidth: 80 }}
                    />
                    <div className="iconText">Contrato</div>
                  </div>
                )}
                <div
                  className="icone"
                  onClick={() => {
                    setShowAtendimentos(true);
                    logNavegacao("Navegacao", "Atendimento");
                  }}
                >
                  <img
                    src={atendimentoIcon}
                    height="80"
                    width="80"
                    alt="Cronograma"
                    style={{ height: 80, width: 80, minWidth: 80 }}
                  />
                  <div className="iconText">Atendimentos</div>
                </div>
                <div
                  className="icone"
                  onClick={() => {
                    openCronograma();
                    logNavegacao("Navegacao", "Cronograma");
                  }}
                >
                  <div className="circuloIcon">
                    <EventNoteIcon
                      sx={{ color: "var(--main-white-color)", fontSize: 60 }}
                    />
                  </div>
                  <div className="iconText">Cronograma de Coletas</div>
                </div>
              <div
                className="icone"
                onClick={() => {
                    setShowUsuarios(true);
                    logNavegacao("Navegacao", "Coleta Extra");
                }}
                >
                  <div style={{backgroundColor: "#a5a5a5", padding: 13, borderRadius: 52, display: "flex", justifyContent: "center", alignItems: "center"}}>
                      <GroupAdd sx={{fontSize: 53, color: "#FFF"}} />
                  </div>
                <div className="iconText">Perfil</div>
              </div>
              </div>
              <div className="cartoes">
                <div className="row">
                  <div
                    className="col-12 col-sm-12 col-xs-6 col-md-6 col-lg-4 col-xl-4"
                    style={{ marginBottom: 20 }}
                  >
                    <div
                      style={{
                        color: "var(--main-secondy)",
                        fontSize: 20,
                        fontWeight: 700,
                      }}
                    >
                      Residuos coletados extras
                    </div>
                    <div
                      style={{
                        color: "var(--main-bg-color)",
                        fontSize: 20,
                        fontWeight: 700,
                      }}
                    >
                      {user.quantidade} unidade(s)
                    </div>
                    <div
                      style={{
                        color: "var(--main-secondy)",
                        fontSize: 14,
                        fontWeight: 300,
                      }}
                    >
                      {user.contratoColeta}
                    </div>
                  </div>
                  <div
                    id="meusContratos"
                    className="col-12 col-sm-12 col-xs-6 col-md-6 col-lg-4 col-xl-4"
                    style={{ marginBottom: 20 }}
                  >
                    <div
                      style={{
                        backgroundColor: "var(--main-secondy25)",
                        padding: 20,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => setState(true)}
                    >
                      <img
                        src={contratoIcon2}
                        height="35"
                        alt="Contrato"
                        style={{ marginRight: 15 }}
                      />
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 300,
                          color: "var(--main-font)",
                        }}
                      >
                        Meus contratos
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-12 col-sm-12 col-xs-6 col-md-6 col-lg-4 col-xl-4"
                    style={{ marginBottom: 20 }}
                  >
                    <div
                      style={{
                        backgroundColor: "var(--main-secondy25)",
                        padding: 20,
                        borderRadius: 14,
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        history.push({
                          pathname: "solucoes",
                          state: { user },
                        });
                        logNavegacao("Navegacao", "Solucoes");
                      }}
                    >
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 400,
                          color: "var(--main-font)",
                        }}
                      >
                        Conheça todas as soluções do{" "}
                        <span
                          style={{
                            color: "var(--main-bg-color)",
                            marginLeft: 5,
                          }}
                        >
                          {" "}
                          Grupo Urbam
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Snackbar
        open={alerta.show}
        onClose={handleCloseAlerta}
        TransitionComponent={transition}
      >
        <Alert
          onClose={handleCloseAlerta}
          severity={alerta.type}
          sx={{ width: "100%" }}
        >
          <AlertTitle>{alerta.title}</AlertTitle>
          {alerta.msg}
        </Alert>
      </Snackbar>
    </>
  );
}

export default Home;
